import { Component } from '@theme/component';

class MuppetPdpCarousel extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.currentIndex = 0;

    const track = this.refs.track;
    if (!track) return;

    this.slides = Array.from(track.querySelectorAll('.muppet-pdp__carousel-slide'));
    if (this.slides.length <= 1) return;

    // Observe which slide is visible
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            const index = this.slides.indexOf(entry.target);
            if (index !== -1) {
              this.currentIndex = index;
              this.updateDots();
              this.updateThumbs();
            }
          }
        }
      },
      {
        root: track,
        threshold: 0.5,
      }
    );

    for (const slide of this.slides) {
      this.observer.observe(slide);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  updateDots() {
    const dotsContainer = this.refs.dots;
    if (!dotsContainer) return;

    const dots = dotsContainer.querySelectorAll('.muppet-pdp__carousel-dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('muppet-pdp__carousel-dot--active', i === this.currentIndex);
    });
  }

  updateThumbs() {
    const thumbsContainer = this.refs.thumbs;
    if (!thumbsContainer) return;

    const thumbs = thumbsContainer.querySelectorAll('.muppet-pdp__thumb');
    thumbs.forEach((thumb) => {
      const thumbIndex = parseInt(thumb.dataset.index, 10);
      thumb.classList.toggle('muppet-pdp__thumb--active', thumbIndex === this.currentIndex);
    });
  }

  goToSlide(event) {
    const button = event.target.closest('[data-index]');
    if (!button) return;

    const index = parseInt(button.dataset.index, 10);
    if (isNaN(index) || !this.slides[index]) return;

    this.slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  prevSlide() {
    const newIndex = Math.max(0, this.currentIndex - 1);
    if (this.slides[newIndex]) {
      this.slides[newIndex].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  }

  nextSlide() {
    const newIndex = Math.min(this.slides.length - 1, this.currentIndex + 1);
    if (this.slides[newIndex]) {
      this.slides[newIndex].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  }
}

if (!customElements.get('muppet-pdp-carousel')) {
  customElements.define('muppet-pdp-carousel', MuppetPdpCarousel);
}
